import { portalJson } from '../lib/portalApi';
import { clearPortalSession, setPortalRole } from '../lib/portalSession';

export type PortalMe = { id: number; account: string; role: string };

/**
 * GET /api/auth/me — role을 서버 기준으로 다시 확인하고 캐시(`ev123_portal_role`)를 갱신.
 * 401(만료/무효 토큰)이면 세션 정리.
 */
export async function fetchPortalMe(): Promise<
  { ok: true; data: PortalMe } | { ok: false; status: number; message: string }
> {
  const r = await portalJson<PortalMe>('/api/auth/me', { auth: true });
  if (!r.ok) {
    if (r.status === 401) {
      clearPortalSession();
    }
    return r;
  }
  setPortalRole(r.data.role);
  return r;
}
